<template>
  <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top" class="navbar-header-doomyoga-customer">
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="mx-auto">
        <b-nav-text class="mx-4"><router-link to="/doom_yoga/home"> Home </router-link> </b-nav-text>
        <b-nav-text class="mx-4"><router-link to="/doom_yoga/events"> Events </router-link> </b-nav-text>
        <b-nav-text class="mx-4" v-if="login_user != null "><router-link to="/doom_yoga/my_profile"> Profile </router-link> </b-nav-text>
        <b-nav-text class="mx-4" v-if="login_user != null "><a href="" @click="logout"> Logout </a> </b-nav-text>
        <b-nav-text class="mx-4" v-if="login_user == null "><router-link to="/doom_yoga/login">Sign in </router-link> </b-nav-text>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>


<script>
export default {
  name: "DoomYogaNavbar",
  data() {
    return {
      login_user: window.localStorage.getItem("user")
    };
  },
  mounted() {
    // console.log("customer home");
    // console.log(window.localStorage.getItem("user"));
    // console.log(window.localStorage.getItem("customer"));
  },
  methods:{
     logout() {
      // console.log("logoutt customer ");
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      localStorage.removeItem("customer");
      localStorage.removeItem("spotify_access_token")
      localStorage.removeItem("spotify_refresh_token")
      localStorage.removeItem("spotify_token_timestamp")
      //  App.isLogin = false;
      this.$router.go({ name: "MIDLogin"}).catch(()=>{});
      // console.log(localStorage);
      //     }
      //   }
      // })
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/partials/navbar_doom_yoga.vue